(() => {
  if (window.__seshIntelligenceLoaded) return;
  window.__seshIntelligenceLoaded = true;

  const KEY = { profile:'sesh:intel:profile:v1', compare:'sesh:intel:compare:v1', replenish:'sesh:intel:replenish:v1' };
  const read = (k,fallback) => { try { return JSON.parse(localStorage.getItem(k) || JSON.stringify(fallback)); } catch(e){ return fallback; } };
  const write = (k,v) => { try { localStorage.setItem(k,JSON.stringify(v)); } catch(e){} };
  const i18n = (() => { try { return JSON.parse(document.querySelector('[data-sesh-intel-i18n]')?.textContent || '{}'); } catch(e){ return {}; } })();
  const isAr = (document.documentElement.lang || '').startsWith('ar');

  const track = (name,data={}) => {
    const safe={event:'sesh_intelligence',sesh_event:name,...data};
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(safe);
    document.dispatchEvent(new CustomEvent('sesh:intelligence',{detail:safe}));
  };

  let catalogCache = null;
  const catalog = () => {
    if (catalogCache) return catalogCache;
    catalogCache = [...document.querySelectorAll('[data-sesh-finder-product]')].map(el=>({
    handle:el.dataset.handle||'',category:el.dataset.category||'more',goals:(el.dataset.goals||'').split(',').filter(Boolean),
    title:el.dataset.title||'',url:el.dataset.url||'',image:el.dataset.image||'',price:Number(el.dataset.price||0),
    priceFormatted:el.dataset.priceFormatted||'',variantId:Number(el.dataset.variantId||0),variantTitle:el.dataset.variantTitle||'',
    available:el.dataset.available==='true',isNew:el.dataset.new==='true',isBest:el.dataset.best==='true',hidden:el.dataset.hidden==='true',
    type:el.dataset.type||'',inventory:Number(el.dataset.inventory||0),tags:(el.dataset.tags||'').toLowerCase(),
    description:el.dataset.description||'',ingredients:el.dataset.ingredients||''
    }));
    return catalogCache;
  };

  const productByHandle = handle => catalog().find(x=>x.handle===handle);
  const profile = () => {
    const p=read(KEY.profile,{visits:0,scores:{},sources:{},lastGoal:'',lastCategory:'',creator:'',campaign:'',source:'',lastSignalAt:0,lastViewedHandle:'',activeInterest:'',activeSource:'',activeAt:0});
    p.scores=p.scores||{};
    p.sources=p.sources||{};
    return p;
  };
  const saveProfile = p => write(KEY.profile,p);

  const bump = (key,amount=1,source='behavior') => {
    if(!key) return;
    const p=profile();
    p.scores[key]=(p.scores[key]||0)+amount;
    if(amount>=1){
      p.sources[key]=source;
      p.lastSignalAt=Date.now();
    }
    if(['brightening','oily','anti_ageing','hydration','sunscreen','fragrance','body','teeth','nails'].includes(key)) p.lastGoal=key;
    if(['skincare','fragrance','body','teeth','nails','bundles','more'].includes(key)) p.lastCategory=key;
    saveProfile(p);
  };

  const setActiveInterest = (key,source='behavior') => {
    if(!key) return;
    const p=profile();
    p.activeInterest=key;
    p.activeSource=source;
    p.activeAt=Date.now();
    p.scores[key]=Math.max(Number(p.scores[key]||0),10);
    p.sources[key]=source;
    p.lastSignalAt=Date.now();
    if(['brightening','oily','anti_ageing','hydration','sunscreen','fragrance','body','teeth','nails'].includes(key)) p.lastGoal=key;
    if(['skincare','fragrance','body','teeth','nails','bundles','more'].includes(key)) p.lastCategory=key;
    saveProfile(p);
    renderAdaptiveHome();
  };

  const interestLabels={
    brightening:{ar:'التصبغات والنضارة',en:'pigmentation & glow'},
    oily:{ar:'البشرة الدهنية والمسام',en:'oily skin & pores'},
    anti_ageing:{ar:'الخطوط والـanti-aging',en:'fine lines & anti-ageing'},
    hydration:{ar:'الترطيب',en:'hydration'},
    sunscreen:{ar:'الحماية من الشمس',en:'sun protection'},
    fragrance:{ar:'العطور',en:'fragrance'},
    body:{ar:'العناية بالجسم',en:'body care'},
    teeth:{ar:'تبييض الأسنان',en:'teeth whitening'},
    nails:{ar:'العناية بالأظافر',en:'nail care'},
    skincare:{ar:'العناية بالبشرة',en:'skincare'}
  };

  const strongInterestSignals = p => {
    const active=p.activeInterest;
    if(active && interestLabels[active]){
      return [[active,Math.max(Number(p.scores?.[active]||0),10)]];
    }
    return Object.entries(p.scores||{})
      .filter(([key,value])=>Number(value)>=1.5 && interestLabels[key])
      .sort((a,b)=>Number(b[1])-Number(a[1]))
      .slice(0,3);
  };

  const interestReason = (key,p) => {
    const label=interestLabels[key]||{ar:key,en:key};
    const source=p.sources?.[key]||'behavior';
    if(source==='finder') return isAr?'بناءً على اختيارك في الـFinder: '+label.ar:'Based on your Finder choice: '+label.en;
    if(source==='campaign') return isAr?'متوافق مع اهتمامك من الحملة اللي دخلتي منها: '+label.ar:'Matches the interest from the campaign you arrived from: '+label.en;
    if(source==='sia') return isAr?'بناءً على اللي سألتي عنه في Ask SESH: '+label.ar:'Based on what you asked in Ask SESH: '+label.en;
    if(source==='product_view'||source==='product_click') return isAr?'بناءً على آخر منتج شفتيه: '+label.ar:'Based on the last product you viewed: '+label.en;
    if(source==='cart') return isAr?'بناءً على اللي ضفتيه للسلة: '+label.ar:'Based on what you added to cart: '+label.en;
    if(source==='compare') return isAr?'بناءً على المنتجات اللي بتقارني بينها: '+label.ar:'Based on what you are comparing: '+label.en;
    if(source==='blog') return isAr?'بناءً على المقال اللي قريتيه: '+label.ar:'Based on the article you read: '+label.en;
    return isAr?'بناءً على اهتمامك بـ'+label.ar:'Based on your interest in '+label.en;
  };

  const captureAttribution = () => {
    const u=new URL(location.href), p=profile();
    const creator=u.searchParams.get('creator')||u.searchParams.get('ref')||'';
    const campaign=u.searchParams.get('utm_campaign')||'';
    const source=u.searchParams.get('utm_source')||'';
    if(creator) p.creator=creator.slice(0,50);
    if(campaign) p.campaign=campaign.slice(0,100);
    if(source) p.source=source.slice(0,50);
    const hay=(campaign+' '+source+' '+u.searchParams.get('utm_content')).toLowerCase();
    const map=[['fragrance',['fragrance','perfume','mist','scent']],['sunscreen',['spf','sun','sunscreen']],['brightening',['bright','pigment','glow']],['oily',['oily','pore','acne']],['body',['body','lotion','dry oil']],['nails',['nail']],['teeth',['teeth','whiten']],['anti_ageing',['anti aging','anti-ageing','wrinkle','fine line']],['hydration',['hydration','dry skin','moisture']]];
    let mapped=false;
    map.forEach(([goal,words])=>{
      if(words.some(w=>hay.includes(w))){
        p.lastGoal=goal;
        p.scores[goal]=(p.scores[goal]||0)+5;
        p.sources=p.sources||{};
        p.sources[goal]='campaign';
        p.lastSignalAt=Date.now();
        mapped=true;
      }
    });
    p.visits=(p.visits||0)+1;
    saveProfile(p);
    if(creator||campaign||source) track('attribution_captured',{has_creator:Boolean(creator),has_campaign:Boolean(campaign),source:source||'direct'});
  };

  const stockScore = item => {
    if(!item.available || item.inventory===0) return -100;
    if(item.inventory>0 && item.inventory<25) return -4;
    if(item.inventory>0 && item.inventory<75) return -1;
    return 2;
  };

  const interestPriority={
    anti_ageing:{
      'effective-magic-anti-wrinkles-cream':100,
      'sesh-ready-in-action':98,
      'sesh-effective-boost':94,
      'nighty-night-cream':90,
      'baby-blue-morning-serum-with-spf30':94,
      'sesh-smart-magic':58,
      'simply-one-sunscreen-fluid-spf50-50ml':28,
      'more-than-sunscreen-cream-gel-spf50':26,
      'simply-renew-weekly-peeeling-solution-1':22
    },
    brightening:{
      'sesh-happy-glow':100,
      'sesh-smart-bright':98,
      'more-than-sunscreen-cream-gel-spf50':82,
      'baby-blue-morning-serum-with-spf30':78,
      'nighty-night-cream':62,
      'simply-renew-weekly-peeeling-solution-1':58,
      'simply-one-sunscreen-fluid-spf50-50ml':42
    },
    oily:{
      'super-smooth-pore-refining-gel':100,
      'super-clear-mattifying-cream':98,
      'super-cleanse-combination-to-oily-skin-cleanser':96
    },
    hydration:{
      'baby-blue-morning-serum-with-spf30':110,
      'nighty-night-cream':108,
      'sesh-effective-boost':100,
      'sesh-ready-in-action':88,
      'sesh-happy-glow':78
    },
    sunscreen:{
      'simply-one-sunscreen-fluid-spf50-50ml':100,
      'more-than-sunscreen-cream-gel-spf50':98,
      'baby-blue-morning-serum-with-spf30':72
    },
    fragrance:{
      'sesh-love-by-sheeka-fragrance-mist':96,
      'sesh-sweet-escape-fragrance-mist':96,
      'sesh-candy-fantasy-fragrance-mist':96,
      'sesh-berry-alure-fragrance-mist':94,
      'sesh-queens-garden-fragrance-mist':94,
      'sesh-secrets-of-cairo-fragrance-mist':94
    },
    body:{
      'happy-shine-dry-oil':100,
      'sesh-love-by-sheeka-body-lotion':96,
      'sesh-berry-alure-body-lotion':94,
      'sesh-queens-garden-body-lotion':94,
      'sesh-secrets-of-cairo-body-lotion':94
    },
    teeth:{'thirty-seconds-teeth-whitening-gel':100},
    nails:{'sesh-best-nails-ever-nail-serum':100}
  };

  const productInterestFit=(item,key)=>{
    const exact=interestPriority[key]?.[item.handle];
    if(Number.isFinite(exact)) return exact;
    if(item.goals.includes(key)||item.category===key) return 60;
    return 0;
  };

  const primaryInterestForItem = item => {
    if(!item) return '';
    const keys=['brightening','oily','anti_ageing','hydration','sunscreen','fragrance','body','teeth','nails'];
    let best='',bestScore=0;
    keys.forEach(key=>{
      const fit=productInterestFit(item,key);
      if(fit>bestScore){best=key;bestScore=fit;}
    });
    if(best) return best;
    if(['fragrance','body','teeth','nails'].includes(item.category)) return item.category;
    return (item.goals||[]).find(g=>interestLabels[g])||'skincare';
  };

  const primaryInterestForItems = items => {
    const totals={};
    (items||[]).filter(Boolean).forEach(item=>{
      ['brightening','oily','anti_ageing','hydration','sunscreen','fragrance','body','teeth','nails'].forEach(key=>{
        const fit=productInterestFit(item,key);
        if(fit>0) totals[key]=(totals[key]||0)+fit;
      });
    });
    return Object.entries(totals).sort((a,b)=>b[1]-a[1])[0]?.[0]||'';
  };

  const interestFromText = raw => {
    const text=String(raw||'').toLowerCase();
    const lanes={
      fragrance:['fragrance','perfume','mist','scent','vanilla','oud','floral','fruity','gourmand','برفان','عطر','عطور','ريحة','ريحه','فانيليا','عود','زهور'],
      sunscreen:['sunscreen','spf','sun protection','uv','uva','uvb','واقي شمس','صن سكرين','شمس'],
      brightening:['brightening','bright','pigment','dark spot','glow','radiance','whitening','uneven tone','تفتيح','تصبغ','تصبغات','بقع','نضارة','نضاره'],
      oily:['oily','pore','pores','acne','blackhead','mattifying','oil control','دهني','دهنية','مسام','حبوب','رؤوس سوداء'],
      hydration:['hydration','hydrate','moisture','dry skin','hyaluronic','ترطيب','جفاف','جاف','جافة'],
      anti_ageing:['anti aging','anti-ageing','wrinkle','fine line','elasticity','firmness','retinol','peptide','تجاعيد','خطوط','مرونة','ترهل','ريتينول','بيبتيد'],
      body:['body care','body lotion','dry oil','lotion','جسم','لوشن','دراي اويل','زيت جسم'],
      teeth:['teeth whitening','oral care','teeth','tooth','سنان','اسنان','أسنان','تبييض الأسنان','تبييض السنان'],
      nails:['nail','nails','cuticle','ضوافر','اظافر','أظافر']
    };
    const scored=Object.entries(lanes).map(([key,words])=>[key,words.reduce((sum,w)=>sum+(text.includes(w)?1:0),0)]).filter(([,score])=>score>0).sort((a,b)=>b[1]-a[1]);
    return scored[0]?.[0]||'';
  };

  const interestFromArticle = raw => {
    const text=String(raw||'').toLowerCase();
    let bestItem=null,bestHits=0;
    catalog().forEach(item=>{
      const words=String(item.title||'').toLowerCase().replace(/[^a-z0-9\u0600-\u06ff\s]/g,' ').split(/\s+/).filter(w=>w.length>3&&!['sesh','serum','cream','body','fragrance'].includes(w));
      const hits=words.filter(w=>text.includes(w)).length;
      if(hits>bestHits){bestHits=hits;bestItem=item;}
    });
    if(bestItem && bestHits>=2) return primaryInterestForItem(bestItem);
    return interestFromText(text);
  };

  const smartCandidates = (count=4) => {
    const p=profile();
    const signals=strongInterestSignals(p);
    if(!signals.length) return [];

    return catalog()
      .filter(x=>!x.hidden && x.available && x.inventory!==0)
      .map(item=>{
        const matches=[];
        for(const [key,value] of signals){
          const fit=productInterestFit(item,key);
          if(fit>0) matches.push({key,value:Number(value),fit,source:p.sources?.[key]||'behavior'});
        }
        if(!matches.length) return null;
        matches.sort((a,b)=>(b.value*b.fit)-(a.value*a.fit));
        const primary=matches[0];
        const relevance=matches.reduce((sum,m)=>sum+(m.value*m.fit),0);
        const score=relevance+stockScore(item)+(item.isNew?.25:0);
        return {...item,score,interestKey:primary.key,interestSource:primary.source,interestReason:interestReason(primary.key,p)};
      })
      .filter(Boolean)
      .sort((a,b)=>b.score-a.score||b.inventory-a.inventory)
      .slice(0,count);
  };

  const renderMini = (item,{compare=true,reason=''}={}) => {
    const article=document.createElement('article'); article.className='sesh-mini-product';
    article.innerHTML='<a href="'+item.url+'"><img src="'+(item.image||'')+'" alt="" loading="lazy" decoding="async"><span>'+item.title+'</span></a>'+
      '<small>'+item.priceFormatted+(reason?' · '+reason:'')+'</small>'+
      '<div class="sesh-adaptive-card__actions"><button type="button" data-sesh-quick-add data-variant-id="'+item.variantId+'">'+(i18n.action_add||'Add')+'</button>'+
      (compare?'<button type="button" data-sesh-compare-add="'+item.handle+'">'+(i18n.action_compare||'Compare')+'</button>':'')+'</div>';
    return article;
  };

  const renderAdaptiveHome = () => {
    const section=document.querySelector('[data-sesh-adaptive-home]'); if(!section) return;
    const p=profile();
    const signals=strongInterestSignals(p);
    if(!signals.length) return;
    const items=smartCandidates(4);
    if(!items.length) return;

    const grid=section.querySelector('[data-sesh-adaptive-grid]');
    grid.innerHTML='';
    items.forEach(item=>{
      const card=document.createElement('article');
      card.className='sesh-adaptive-card';
      card.dataset.interestKey=item.interestKey||'';
      card.dataset.interestSource=item.interestSource||'';
      card.innerHTML=
        '<a class="sesh-adaptive-card__image" href="'+item.url+'"><img src="'+(item.image||'')+'" alt="" loading="lazy" decoding="async"></a>'+
        '<a href="'+item.url+'">'+item.title+'</a>'+
        '<small class="sesh-adaptive-card__reason">'+item.interestReason+'</small>'+
        '<small>'+item.priceFormatted+'</small>'+
        '<div class="sesh-adaptive-card__actions"><button type="button" data-sesh-quick-add data-variant-id="'+item.variantId+'">'+(i18n.action_add||'Add')+'</button><button type="button" data-sesh-compare-add="'+item.handle+'">'+(i18n.action_compare||'Compare')+'</button></div>';
      grid.appendChild(card);
    });

    const primaryKey=signals[0][0];
    const label=interestLabels[primaryKey]||{ar:primaryKey,en:primaryKey};
    const heading=section.querySelector('[data-sesh-adaptive-heading]');
    const copy=section.querySelector('[data-sesh-adaptive-copy]');
    if(heading) heading.textContent=i18n.adaptive_heading||'Picks tied to your interests';
    if(copy) copy.textContent=i18n.adaptive_copy||'These picks come from real signals in your SESH journey, with the reason shown on every product.';

    const note=section.querySelector('[data-sesh-campaign-note]');
    if(note && p.sources?.[primaryKey]==='campaign'){
      note.hidden=false;
      note.textContent=(i18n.adaptive_campaign||'Current campaign interest: {interest}').replace('{interest}',isAr?label.ar:label.en);
      note.classList.add('sesh-creator-welcome');
    }else if(note){
      note.hidden=true;
    }

    section.hidden=false;
    track('adaptive_home_rendered',{interest:primaryKey,source:p.sources?.[primaryKey]||'behavior',items:items.length});
  };


  const compareOverrides = {
    'sesh-effective-boost':{role:i18n.pf_sesh_effective_boost_role,type:i18n.pf_sesh_effective_boost_type,when:i18n.pf_sesh_effective_boost_when,area:i18n.pf_sesh_effective_boost_area,retinoid:false,actives:['Hyaluronic Acid','Proteins','Vitamins'],difference:i18n.pf_sesh_effective_boost_difference},
    'sesh-happy-glow':{role:i18n.pf_sesh_happy_glow_role,type:i18n.pf_sesh_happy_glow_type,when:i18n.pf_sesh_happy_glow_when,area:i18n.pf_sesh_happy_glow_area,retinoid:false,actives:['Niacinamide','Alpha Arbutin','Vitamin C','Vitamin E','Hyaluronic Acid'],difference:i18n.pf_sesh_happy_glow_difference},
    'sesh-melt-the-day-away':{role:i18n.pf_sesh_melt_the_day_away_role,type:i18n.pf_sesh_melt_the_day_away_type,when:i18n.pf_sesh_melt_the_day_away_when,area:i18n.pf_sesh_melt_the_day_away_area,retinoid:false,actives:[],difference:i18n.pf_sesh_melt_the_day_away_difference},
    'sesh-ready-in-action':{role:i18n.pf_sesh_ready_in_action_role,type:i18n.pf_sesh_ready_in_action_type,when:i18n.pf_sesh_ready_in_action_when,area:i18n.pf_sesh_ready_in_action_area,retinoid:false,actives:['Q10','Peptides','Hyaluronic Acid','Ceramides','Marine Collagen'],difference:i18n.pf_sesh_ready_in_action_difference},
    'sesh-smart-bright':{role:i18n.pf_sesh_smart_bright_role,type:i18n.pf_sesh_smart_bright_type,when:i18n.pf_sesh_smart_bright_when,area:i18n.pf_sesh_smart_bright_area,retinoid:false,actives:['Sepiwhite','Alpha Arbutin','Rosehip'],difference:i18n.pf_sesh_smart_bright_difference},
    'sesh-smart-magic':{role:i18n.pf_sesh_smart_magic_role,type:i18n.pf_sesh_smart_magic_type,when:i18n.pf_sesh_smart_magic_when,area:i18n.pf_sesh_smart_magic_area,retinoid:true,actives:['Retinol','Peptides','Caffeine'],difference:i18n.pf_sesh_smart_magic_difference},
    'simply-one-sunscreen-fluid-spf50-50ml':{role:i18n.pf_simply_one_sunscreen_fluid_spf50_50ml_role,type:i18n.pf_simply_one_sunscreen_fluid_spf50_50ml_type,when:i18n.pf_simply_one_sunscreen_fluid_spf50_50ml_when,area:i18n.pf_simply_one_sunscreen_fluid_spf50_50ml_area,retinoid:false,actives:['7 UV Filters'],difference:i18n.pf_simply_one_sunscreen_fluid_spf50_50ml_difference},
    'simply-renew-weekly-peeeling-solution-1':{role:i18n.pf_simply_renew_weekly_peeeling_solution_1_role,type:i18n.pf_simply_renew_weekly_peeeling_solution_1_type,when:i18n.pf_simply_renew_weekly_peeeling_solution_1_when,area:i18n.pf_simply_renew_weekly_peeeling_solution_1_area,retinoid:false,actives:['AHAs','BHAs','Ceramides','Hyaluronic Acid'],difference:i18n.pf_simply_renew_weekly_peeeling_solution_1_difference},
    'super-cleanse-combination-to-oily-skin-cleanser':{role:i18n.pf_super_cleanse_combination_to_oily_skin_cleanser_role,type:i18n.pf_super_cleanse_combination_to_oily_skin_cleanser_type,when:i18n.pf_super_cleanse_combination_to_oily_skin_cleanser_when,area:i18n.pf_super_cleanse_combination_to_oily_skin_cleanser_area,retinoid:false,actives:['Glycolic Acid','Salicylic Acid','Niacinamide'],difference:i18n.pf_super_cleanse_combination_to_oily_skin_cleanser_difference},
    'super-smooth-pore-refining-gel':{role:i18n.pf_super_smooth_pore_refining_gel_role,type:i18n.pf_super_smooth_pore_refining_gel_type,when:i18n.pf_super_smooth_pore_refining_gel_when,area:i18n.pf_super_smooth_pore_refining_gel_area,retinoid:false,actives:['Salicylic Acid','Niacinamide','Lactic Acid','Centella'],difference:i18n.pf_super_smooth_pore_refining_gel_difference},
    'effective-magic-anti-wrinkles-cream':{role:i18n.pf_effective_magic_anti_wrinkles_cream_role,type:i18n.pf_effective_magic_anti_wrinkles_cream_type,when:i18n.pf_effective_magic_anti_wrinkles_cream_when,area:i18n.pf_effective_magic_anti_wrinkles_cream_area,retinoid:true,actives:['Retinol','Q10','Peptides'],difference:i18n.pf_effective_magic_anti_wrinkles_cream_difference},
    'happy-shine-dry-oil':{role:i18n.pf_happy_shine_dry_oil_role,type:i18n.pf_happy_shine_dry_oil_type,when:i18n.pf_happy_shine_dry_oil_when,area:i18n.pf_happy_shine_dry_oil_area,retinoid:false,actives:['10% Squalane','10-Oil Blend'],difference:i18n.pf_happy_shine_dry_oil_difference},
    'super-clear-mattifying-cream':{role:i18n.pf_super_clear_mattifying_cream_role,type:i18n.pf_super_clear_mattifying_cream_type,when:i18n.pf_super_clear_mattifying_cream_when,area:i18n.pf_super_clear_mattifying_cream_area,retinoid:false,actives:[],difference:i18n.pf_super_clear_mattifying_cream_difference},
    'thirty-seconds-teeth-whitening-gel':{role:i18n.pf_thirty_seconds_teeth_whitening_gel_role,type:i18n.pf_thirty_seconds_teeth_whitening_gel_type,when:i18n.pf_thirty_seconds_teeth_whitening_gel_when,area:i18n.pf_thirty_seconds_teeth_whitening_gel_area,retinoid:false,actives:[],difference:i18n.pf_thirty_seconds_teeth_whitening_gel_difference},
    'sesh-best-nails-ever-nail-serum':{role:i18n.pf_sesh_best_nails_ever_nail_serum_role,type:i18n.pf_sesh_best_nails_ever_nail_serum_type,when:i18n.pf_sesh_best_nails_ever_nail_serum_when,area:i18n.pf_sesh_best_nails_ever_nail_serum_area,retinoid:false,actives:[],difference:i18n.pf_sesh_best_nails_ever_nail_serum_difference},
    'sesh-berry-alure-body-lotion':{role:i18n.pf_sesh_berry_alure_body_lotion_role,type:i18n.pf_sesh_berry_alure_body_lotion_type,when:i18n.pf_sesh_berry_alure_body_lotion_when,area:i18n.pf_sesh_berry_alure_body_lotion_area,retinoid:false,actives:[],difference:i18n.pf_sesh_berry_alure_body_lotion_difference},
    'sesh-berry-alure-fragrance-mist':{role:i18n.pf_sesh_berry_alure_fragrance_mist_role,type:i18n.pf_sesh_berry_alure_fragrance_mist_type,when:i18n.pf_sesh_berry_alure_fragrance_mist_when,area:i18n.pf_sesh_berry_alure_fragrance_mist_area,retinoid:false,actives:[],difference:i18n.pf_sesh_berry_alure_fragrance_mist_difference},
    'sesh-queens-garden-body-lotion':{role:i18n.pf_sesh_queens_garden_body_lotion_role,type:i18n.pf_sesh_queens_garden_body_lotion_type,when:i18n.pf_sesh_queens_garden_body_lotion_when,area:i18n.pf_sesh_queens_garden_body_lotion_area,retinoid:false,actives:[],difference:i18n.pf_sesh_queens_garden_body_lotion_difference},
    'sesh-queens-garden-fragrance-mist':{role:i18n.pf_sesh_queens_garden_fragrance_mist_role,type:i18n.pf_sesh_queens_garden_fragrance_mist_type,when:i18n.pf_sesh_queens_garden_fragrance_mist_when,area:i18n.pf_sesh_queens_garden_fragrance_mist_area,retinoid:false,actives:[],difference:i18n.pf_sesh_queens_garden_fragrance_mist_difference},
    'sesh-secrets-of-cairo-body-lotion':{role:i18n.pf_sesh_secrets_of_cairo_body_lotion_role,type:i18n.pf_sesh_secrets_of_cairo_body_lotion_type,when:i18n.pf_sesh_secrets_of_cairo_body_lotion_when,area:i18n.pf_sesh_secrets_of_cairo_body_lotion_area,retinoid:false,actives:[],difference:i18n.pf_sesh_secrets_of_cairo_body_lotion_difference},
    'sesh-secrets-of-cairo-fragrance-mist':{role:i18n.pf_sesh_secrets_of_cairo_fragrance_mist_role,type:i18n.pf_sesh_secrets_of_cairo_fragrance_mist_type,when:i18n.pf_sesh_secrets_of_cairo_fragrance_mist_when,area:i18n.pf_sesh_secrets_of_cairo_fragrance_mist_area,retinoid:false,actives:[],difference:i18n.pf_sesh_secrets_of_cairo_fragrance_mist_difference},
    'baby-blue-morning-serum-with-spf30':{role:i18n.pf_baby_blue_morning_serum_with_spf30_role,type:i18n.pf_baby_blue_morning_serum_with_spf30_type,when:i18n.pf_baby_blue_morning_serum_with_spf30_when,area:i18n.pf_baby_blue_morning_serum_with_spf30_area,retinoid:false,actives:['Copper Tripeptide','Argireline'],difference:i18n.pf_baby_blue_morning_serum_with_spf30_difference},
    'nighty-night-cream':{role:i18n.pf_nighty_night_cream_role,type:i18n.pf_nighty_night_cream_type,when:i18n.pf_nighty_night_cream_when,area:i18n.pf_nighty_night_cream_area,retinoid:false,actives:['Copper Peptides','Argireline','Ashwagandha','Ginseng','Lotus Extract'],difference:i18n.pf_nighty_night_cream_difference},
    'sesh-love-by-sheeka-fragrance-mist':{role:i18n.pf_sesh_love_by_sheeka_fragrance_mist_role,type:i18n.pf_sesh_love_by_sheeka_fragrance_mist_type,when:i18n.pf_sesh_love_by_sheeka_fragrance_mist_when,area:i18n.pf_sesh_love_by_sheeka_fragrance_mist_area,retinoid:false,actives:[],difference:i18n.pf_sesh_love_by_sheeka_fragrance_mist_difference},
    'sesh-love-by-sheeka-influencers-box-set-of-two':{role:i18n.pf_sesh_love_by_sheeka_influencers_box_set_of_two_role,type:i18n.pf_sesh_love_by_sheeka_influencers_box_set_of_two_type,when:i18n.pf_sesh_love_by_sheeka_influencers_box_set_of_two_when,area:i18n.pf_sesh_love_by_sheeka_influencers_box_set_of_two_area,retinoid:false,actives:[],difference:i18n.pf_sesh_love_by_sheeka_influencers_box_set_of_two_difference},
    'sesh-love-by-sheeka-body-lotion':{role:i18n.pf_sesh_love_by_sheeka_body_lotion_role,type:i18n.pf_sesh_love_by_sheeka_body_lotion_type,when:i18n.pf_sesh_love_by_sheeka_body_lotion_when,area:i18n.pf_sesh_love_by_sheeka_body_lotion_area,retinoid:false,actives:[],difference:i18n.pf_sesh_love_by_sheeka_body_lotion_difference},
    'love-by-sheeka-full-experience-box-mist-lotion':{role:i18n.pf_love_by_sheeka_full_experience_box_mist_lotion_role,type:i18n.pf_love_by_sheeka_full_experience_box_mist_lotion_type,when:i18n.pf_love_by_sheeka_full_experience_box_mist_lotion_when,area:i18n.pf_love_by_sheeka_full_experience_box_mist_lotion_area,retinoid:false,actives:[],difference:i18n.pf_love_by_sheeka_full_experience_box_mist_lotion_difference},
    'more-than-sunscreen-cream-gel-spf50':{role:i18n.pf_more_than_sunscreen_cream_gel_spf50_role,type:i18n.pf_more_than_sunscreen_cream_gel_spf50_type,when:i18n.pf_more_than_sunscreen_cream_gel_spf50_when,area:i18n.pf_more_than_sunscreen_cream_gel_spf50_area,retinoid:false,actives:['Tranexamic Acid','Peptide Q10','Vitamin E'],difference:i18n.pf_more_than_sunscreen_cream_gel_spf50_difference},
    'sesh-sweet-escape-fragrance-mist':{role:i18n.pf_sesh_sweet_escape_fragrance_mist_role,type:i18n.pf_sesh_sweet_escape_fragrance_mist_type,when:i18n.pf_sesh_sweet_escape_fragrance_mist_when,area:i18n.pf_sesh_sweet_escape_fragrance_mist_area,retinoid:false,actives:[],difference:i18n.pf_sesh_sweet_escape_fragrance_mist_difference},
    'sesh-candy-fantasy-fragrance-mist':{role:i18n.pf_sesh_candy_fantasy_fragrance_mist_role,type:i18n.pf_sesh_candy_fantasy_fragrance_mist_type,when:i18n.pf_sesh_candy_fantasy_fragrance_mist_when,area:i18n.pf_sesh_candy_fantasy_fragrance_mist_area,retinoid:false,actives:[],difference:i18n.pf_sesh_candy_fantasy_fragrance_mist_difference},
    'sesh-tote-bag-beach-please':{role:i18n.pf_sesh_tote_bag_beach_please_role,type:i18n.pf_sesh_tote_bag_beach_please_type,when:i18n.pf_sesh_tote_bag_beach_please_when,area:i18n.pf_sesh_tote_bag_beach_please_area,retinoid:false,actives:[],difference:i18n.pf_sesh_tote_bag_beach_please_difference},
    'sesh-tote-bag-haty-boosa':{role:i18n.pf_sesh_tote_bag_haty_boosa_role,type:i18n.pf_sesh_tote_bag_haty_boosa_type,when:i18n.pf_sesh_tote_bag_haty_boosa_when,area:i18n.pf_sesh_tote_bag_haty_boosa_area,retinoid:false,actives:[],difference:i18n.pf_sesh_tote_bag_haty_boosa_difference},
    'sesh-sweet-escape-influencers-box-set-of-two':{role:i18n.pf_sesh_sweet_escape_influencers_box_set_of_two_role,type:i18n.pf_sesh_sweet_escape_influencers_box_set_of_two_type,when:i18n.pf_sesh_sweet_escape_influencers_box_set_of_two_when,area:i18n.pf_sesh_sweet_escape_influencers_box_set_of_two_area,retinoid:false,actives:[],difference:i18n.pf_sesh_sweet_escape_influencers_box_set_of_two_difference},
    'sesh-candy-fantazy-influencers-box-set-of-two':{role:i18n.pf_sesh_candy_fantazy_influencers_box_set_of_two_role,type:i18n.pf_sesh_candy_fantazy_influencers_box_set_of_two_type,when:i18n.pf_sesh_candy_fantazy_influencers_box_set_of_two_when,area:i18n.pf_sesh_candy_fantazy_influencers_box_set_of_two_area,retinoid:false,actives:[],difference:i18n.pf_sesh_candy_fantazy_influencers_box_set_of_two_difference},
  };

  const activeMap = [
    ['Retinal',['retinal']],['Retinol',['retinol']],['Retinyl',['retinyl']],
    ['Peptides',['peptide','peptides','argireline']],['Q10',['q10','coenzyme q10']],
    ['Ceramides',['ceramide']],['Hyaluronic Acid',['hyaluronic']],
    ['Squalane',['squalane']],['Niacinamide',['niacinamide']],
    ['Alpha Arbutin',['alpha arbutin']],['Vitamin C',['vitamin c']],
    ['Vitamin E',['vitamin e']],['Salicylic Acid',['salicylic']],
    ['Glycolic Acid',['glycolic']],['Lactic Acid',['lactic acid']],
    ['Tranexamic Acid',['tranexamic']],['Caffeine',['caffeine']],
    ['Copper Peptides',['copper peptide','copper tripeptide']],['Collagen',['collagen']]
  ];

  const cleanClassifierText = value => String(value||'')
    .toLowerCase()
    .replace(/fragrance[-\s]?free/g,'')
    .replace(/perfume[-\s]?free/g,'')
    .replace(/unscented/g,'')
    .replace(/non[-\s]?fragranced/g,'')
    .replace(/\s+/g,' ')
    .trim();

  const extractCompareActives = item => {
    const hay=cleanClassifierText((item.title||'')+' '+(item.tags||'')+' '+(item.description||'')+' '+(item.ingredients||''));
    return activeMap.filter(([,words])=>words.some(w=>hay.includes(w))).map(([name])=>name).slice(0,6);
  };

  const inferCompareProfile = item => {
    if(compareOverrides[item.handle]) return compareOverrides[item.handle];

    const title=cleanClassifierText(item.title);
    const type=cleanClassifierText(item.type);
    const tags=cleanClassifierText(item.tags);
    const description=cleanClassifierText(item.description);
    const hay=[title,type,tags,description,item.ingredients||''].join(' ');
    const actives=extractCompareActives(item);
    const tagList=String(item.tags||'').toLowerCase().split(',').map(x=>x.trim()).filter(Boolean);
    const tagHas=value=>tagList.includes(value.toLowerCase());
    const titleHas=value=>title.includes(value.toLowerCase());

    let kind='general';
    if(tagHas('bundle')||titleHas('box')||titleHas('bundle')) kind='bundle';
    else if(type.includes('bags')||tagHas('merchandise')||titleHas('tote bag')) kind='merch';
    else if(tagHas('oral care')||titleHas('teeth')||titleHas('tooth')) kind='teeth';
    else if(tagHas('nail care')||titleHas('nail')) kind='nails';
    else if(tagHas('eye care')||titleHas('eye cream')) kind='eye';
    else if(tagHas('suncare')||titleHas('sunscreen')||/\bspf\s?\d/i.test(item.title||'')) kind='sunscreen';
    else if(tagHas('body lotion')||titleHas('body lotion')) kind='body_lotion';
    else if(titleHas('dry oil')) kind='dry_oil';
    else if(tagHas('fragrance')||titleHas('fragrance mist')||titleHas('perfume')) kind='fragrance';
    else if(type.includes('makeup removal')||titleHas('makeup remover')) kind='makeup_removal';
    else if(type.includes('cleanser')||titleHas('cleanser')) kind='cleanser';
    else if(titleHas('peeling')||description.includes('weekly peeling')||description.includes('ahas')||description.includes('bhas')) kind='peel';
    else if(type.includes('serum')||titleHas('serum')) kind='serum';
    else if(type.includes('cream')||titleHas('cream')) kind='cream';
    else if(type.includes('body care')||tagHas('body care')) kind='body';

    let role=i18n.infer_general_role,displayType=item.type||item.category,when=i18n.infer_general_when,area=i18n.infer_face,difference=i18n.infer_general_difference;

    if(kind==='sunscreen'){
      role=i18n.infer_sunscreen_role;displayType=i18n.infer_sunscreen_type;when=i18n.infer_sunscreen_when;area=tagHas('body care')?i18n.infer_face_body:i18n.infer_face;difference=i18n.infer_sunscreen_difference;
    }else if(kind==='fragrance'){
      role=i18n.infer_fragrance_role;displayType=i18n.infer_fragrance_type;when=i18n.infer_anytime;area=i18n.infer_body;difference=i18n.infer_fragrance_difference;
    }else if(kind==='body_lotion'){
      role=i18n.infer_body_lotion_role;displayType=i18n.infer_body_lotion_type;when=i18n.infer_anytime;area=i18n.infer_body;difference=i18n.infer_body_lotion_difference;
    }else if(kind==='dry_oil'){
      role=i18n.infer_dry_oil_role;displayType=i18n.infer_dry_oil_type;when=i18n.infer_anytime;area=description.includes('hair')?i18n.infer_body_hair:i18n.infer_body;difference=i18n.infer_dry_oil_difference;
    }else if(kind==='eye'){
      role=i18n.infer_eye_role;displayType=i18n.infer_eye_type;when=/retinol|retinal|retinyl/.test(hay)?i18n.infer_pm:i18n.infer_as_directed;area=i18n.infer_eye;difference=i18n.infer_eye_difference;
    }else if(kind==='teeth'){
      role=i18n.infer_teeth_role;displayType=i18n.infer_teeth_type;when=i18n.infer_as_directed;area=i18n.infer_teeth;difference=i18n.infer_teeth_difference;
    }else if(kind==='nails'){
      role=i18n.infer_nails_role;displayType=i18n.infer_nails_type;when=i18n.infer_as_directed;area=i18n.infer_nails;difference=i18n.infer_nails_difference;
    }else if(kind==='cleanser'){
      role=i18n.infer_cleanser_role;displayType=i18n.infer_cleanser_type;when=i18n.infer_cleanser_when;area=i18n.infer_face;difference=i18n.infer_cleanser_difference;
    }else if(kind==='makeup_removal'){
      role=i18n.infer_makeup_role;displayType=i18n.infer_makeup_type;when=i18n.infer_pm;area=i18n.infer_face;difference=i18n.infer_makeup_difference;
    }else if(kind==='peel'){
      role=i18n.infer_peel_role;displayType=i18n.infer_peel_type;when=i18n.infer_peel_when;area=i18n.infer_face_body;difference=i18n.infer_peel_difference;
    }else if(kind==='serum'){
      role=i18n.infer_serum_role;displayType=i18n.infer_serum_type;area=i18n.infer_face;difference=i18n.infer_serum_difference;
    }else if(kind==='cream'){
      role=i18n.infer_cream_role;displayType=i18n.infer_cream_type;area=i18n.infer_face;difference=i18n.infer_cream_difference;
    }else if(kind==='bundle'){
      role=i18n.infer_bundle_role;displayType=i18n.infer_bundle_type;when=i18n.infer_bundle_when;area=i18n.infer_product_set;difference=i18n.infer_bundle_difference;
    }else if(kind==='merch'){
      role=i18n.infer_merch_role;displayType=i18n.infer_merch_type;when=i18n.infer_anytime;area=i18n.infer_accessory;difference=i18n.infer_merch_difference;
    }

    const retinoid=/retinol|retinal|retinyl/.test(hay);
    if(retinoid && when===i18n.infer_general_when) when=i18n.infer_pm;
    return {role,type:displayType,when,area,retinoid,actives,difference,kind,inferred:true};
  };

  const compareSummaryText = (items,profiles) => {
    if(items.length<2) return '';
    const areas=new Set(profiles.map(p=>p.area));
    const categories=new Set(items.map(i=>i.category));
    if(areas.size>1 || categories.size>1){
      return i18n.compare_not_substitutes;
    }
    return i18n.compare_neutral_summary;
  };


  const compareList = () => read(KEY.compare,[]);
  const updateCompareButtons = () => {
    const list=compareList();
    document.querySelectorAll('[data-sesh-compare-count]').forEach(el=>el.textContent=list.length);
    document.querySelectorAll('[data-sesh-open-compare]').forEach(el=>el.hidden=list.length===0);
    document.querySelectorAll('[data-sesh-compare-add]').forEach(b=>{
      const h=b.dataset.seshCompareAdd; const added=list.includes(h);
      b.classList.toggle('is-added',added);
      b.textContent=added?(i18n.action_added||'Added'):(i18n.action_compare||'Compare');
    });
  };
  const renderCompare = () => {
    const grid=document.querySelector('[data-sesh-compare-grid]');
    const empty=document.querySelector('[data-sesh-compare-empty]');
    const summary=document.querySelector('[data-sesh-compare-summary]');
    if(!grid) return;

    const items=compareList().map(productByHandle).filter(Boolean);
    const profiles=items.map(inferCompareProfile);
    grid.innerHTML='';
    if(empty) empty.hidden=items.length>0;
    if(summary){
      const copy=compareSummaryText(items,profiles);
      summary.textContent=copy;
      summary.hidden=!copy;
    }

    items.forEach((item,index)=>{
      const p=profiles[index];
      const stock=!item.available||item.inventory===0?i18n.compare_sold:(item.inventory>0&&item.inventory<50?i18n.compare_low:i18n.compare_available);
      const role=p.role;
      const when=p.when;
      const area=p.area;
      const difference=p.difference;
      const actives=(p.actives&&p.actives.length?p.actives:extractCompareActives(item));
      const card=document.createElement('article');
      card.className='sesh-compare-card';
      card.innerHTML=
        '<img src="'+(item.image||'')+'" alt="" loading="lazy" decoding="async">'+
        '<a class="sesh-compare-card__title" href="'+item.url+'">'+item.title+'</a>'+
        '<p class="sesh-compare-card__difference">'+difference+'</p>'+
        '<dl>'+
          '<div><dt>'+i18n.compare_role+'</dt><dd>'+role+'</dd></div>'+
          '<div><dt>'+i18n.compare_type+'</dt><dd>'+(p.type||item.type||item.category)+'</dd></div>'+
          '<div><dt>'+i18n.compare_when+'</dt><dd>'+when+'</dd></div>'+
          '<div><dt>'+i18n.compare_area+'</dt><dd>'+area+'</dd></div>'+
          '<div><dt>'+i18n.compare_retinoid+'</dt><dd>'+(p.retinoid?i18n.compare_yes:i18n.compare_no)+'</dd></div>'+
          '<div><dt>'+i18n.compare_actives+'</dt><dd>'+(actives.length?actives.join(' · '):i18n.compare_from_formula)+'</dd></div>'+
          '<div><dt>'+i18n.compare_price+'</dt><dd>'+item.priceFormatted+'</dd></div>'+
          '<div><dt>'+i18n.compare_stock+'</dt><dd>'+stock+'</dd></div>'+
        '</dl>'+
        '<button type="button" data-sesh-compare-remove="'+item.handle+'">'+i18n.compare_remove+'</button>';
      grid.appendChild(card);
    });
    track('compare_opened',{count:items.length});
  };

  const toggleCompare = handle => {
    let list=compareList(); const exists=list.includes(handle);
    list=exists?list.filter(h=>h!==handle):[...list.filter(h=>h!==handle),handle].slice(-3);
    write(KEY.compare,list); updateCompareButtons(); renderCompare();
    const comparedItems=list.map(productByHandle).filter(Boolean);
    const compareInterest=primaryInterestForItems(comparedItems);
    if(compareInterest) setActiveInterest(compareInterest,'compare');
    track(exists?'compare_removed':'compare_added',{handle,count:list.length});
  };

  const renderWhy = () => {
    const box=document.querySelector('[data-sesh-why]'); const current=document.querySelector('[data-sesh-product-data]'); if(!box||!current) return;
    const item=productByHandle(current.dataset.handle), p=profile(); let text=i18n.why_generic;
    if(item && p.lastGoal && item.goals.includes(p.lastGoal)) text=i18n.why_goal;
    else if(item && (p.campaign||p.source)) text=i18n.why_campaign;
    box.querySelector('[data-sesh-why-copy]').textContent=text;
  };

  const injectSiaNavigation = () => {
    const makeItem=()=> {
      const li=document.createElement('li');
      li.dataset.seshSiaMenu='';
      li.className='sesh-sia-menu-item';
      li.innerHTML='<a class="menu-link sesh-sia-menu-link" href="/pages/sia"><span>SIA</span><span class="sesh-sia-menu-star" aria-hidden="true">✦</span></a>';
      return li;
    };
    const desktop=document.querySelector('#site-header .site-nav.style--classic .link-list');
    if(desktop&&!desktop.querySelector('[data-sesh-sia-menu]')) desktop.appendChild(makeItem());
    const mobile=document.querySelector('#site-menu-sidebar .site-nav.style--sidebar .link-list');
    if(mobile&&!mobile.querySelector('[data-sesh-sia-menu]')) mobile.appendChild(makeItem());
  };

  const injectFinderShortcuts = () => {
    const dialog=document.querySelector('[data-sesh-finder-dialog]'); if(!dialog||dialog.querySelector('[data-sesh-intel-shortcuts]')) return;
    const modes=dialog.querySelector('.sesh-finder-mode-tabs'); if(!modes) return;
    const row=document.createElement('div'); row.className='sesh-intel-shortcuts'; row.dataset.seshIntelShortcuts='';
    row.innerHTML='<button type="button" data-sesh-open-copilot>'+i18n.shortcut_copilot+'</button><button type="button" data-sesh-open-fragrance>'+i18n.shortcut_fragrance+'</button>';
    modes.insertAdjacentElement('afterend',row);
  };

  const openDialog = sel => { const d=document.querySelector(sel); if(d?.showModal) d.showModal(); };

  const loadConcierge = () => {
    const dialog=document.querySelector('[data-sesh-concierge]');
    if(!dialog) return;
    if(window.SeshConciergeInit){ window.SeshConciergeInit(); return; }
    if(document.querySelector('script[data-sesh-concierge-loader]')) return;
    const script=document.createElement('script');
    script.src=dialog.dataset.seshConciergeSrc;
    script.defer=true;
    script.dataset.seshConciergeLoader='';
    script.addEventListener('load',()=>window.SeshConciergeInit?.());
    document.head.appendChild(script);
  };

  const fragranceMap={
    'sesh-candy-fantasy-fragrance-mist':['sweet','fruity'],
    'sesh-sweet-escape-fragrance-mist':['sweet'],
    'sesh-love-by-sheeka-fragrance-mist':['sweet','floral'],
    'sesh-berry-alure-fragrance-mist':['fruity','fresh'],
    'sesh-queens-garden-fragrance-mist':['floral','fresh'],
    'sesh-secrets-of-cairo-fragrance-mist':['oud']
  };
  const runFragrance = mood => {
    document.querySelectorAll('[data-sesh-fragrance-mood]').forEach(b=>b.classList.toggle('is-selected',b.dataset.seshFragranceMood===mood));
    const wrap=document.querySelector('[data-sesh-fragrance-results]'); if(!wrap) return; wrap.innerHTML='';
    let items=catalog().filter(x=>x.category==='fragrance'&&x.available&&x.inventory!==0&&(fragranceMap[x.handle]||[]).includes(mood)).map(x=>({...x,score:(x.isNew?2:0)+stockScore(x)})).sort((a,b)=>b.score-a.score).slice(0,3);
    items.forEach(x=>wrap.appendChild(renderMini(x,{reason:mood}))); bump('fragrance',2); track('fragrance_profile',{mood,results:items.length});
  };

  const routineStep = item => {
    const t=(item.title+' '+item.tags+' '+item.type).toLowerCase();
    if(t.includes('clean')||t.includes('remover')) return 'cleanse';
    if(t.includes('sunscreen')||t.includes('spf')) return 'spf';
    if(t.includes('cream')||t.includes('lotion')) return 'moisturize';
    return 'treat';
  };
  const renderRoutineTimeline = () => {
    const results=document.querySelector('[data-sesh-finder-results]'); if(!results||results.hidden) return;
    const selected=document.querySelector('[data-sesh-finder-goals] button.is-selected')?.dataset.goal||'';
    if(['fragrance','body','teeth','nails'].includes(selected)) { results.querySelector('[data-sesh-routine-timeline]')?.remove(); return; }
    let box=results.querySelector('[data-sesh-routine-timeline]'); if(!box){box=document.createElement('div');box.className='sesh-routine-timeline';box.dataset.seshRoutineTimeline='';results.appendChild(box);}
    const links=[...results.querySelectorAll('[data-sesh-finder-results-grid] a')].map(a=>new URL(a.href,location.origin).pathname.split('/products/')[1]).filter(Boolean);
    const items=links.map(productByHandle).filter(Boolean); const am=[],pm=[];
    items.forEach(item=>{const step=routineStep(item); if(step==='spf') am.push([step,item]); else if(step==='cleanse'){am.push([step,item]);pm.push([step,item]);} else {am.push([step,item]);pm.push([step,item]);}});
    const row=(label,arr)=>'<div class="sesh-routine-row"><span>'+label+'</span><div class="sesh-routine-steps">'+arr.map(([s,i])=>'<span class="sesh-routine-step">'+s+' · '+i.title+'</span>').join('')+'</div></div>';
    box.innerHTML='<strong>'+i18n.routine_heading+'</strong>'+row(i18n.routine_am||'AM',am)+row(i18n.routine_pm||'PM',pm);
  };

  const rememberAdd = variantId => {
    const item=catalog().find(x=>String(x.variantId)===String(variantId)); if(!item) return;
    const list=read(KEY.replenish,[]).filter(x=>x.handle!==item.handle);
    list.push({handle:item.handle,at:Date.now(),category:item.category});
    write(KEY.replenish,list.slice(-20));

    const focus=primaryInterestForItem(item);
    if(focus){
      bump(focus,8,'cart');
      setActiveInterest(focus,'cart');
      track('cart_interest',{handle:item.handle,interest:focus});
    }
  };
  const showReplenish = () => {
    const list=read(KEY.replenish,[]), now=Date.now();
    const due=list.map(entry=>({entry,item:productByHandle(entry.handle)})).find(({entry,item})=>{
      if(!item) return false; const days=(now-entry.at)/86400000; const threshold=item.category==='fragrance'?75:item.category==='body'?45:32; return days>=threshold;
    });
    const toast=document.querySelector('[data-sesh-replenish]'); if(!toast||!due) return;
    toast.hidden=false; toast.querySelector('[data-sesh-replenish-link]').href=due.item.url; track('replenishment_prompt',{category:due.item.category});
  };

  const readActiveOffers = coach => {
    try {
      const node = coach?.querySelector('[data-sesh-active-offers]');
      const parsed = JSON.parse(node?.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(offer => String(offer?.status || '').toUpperCase() === 'ACTIVE') : [];
    } catch (error) {
      return [];
    }
  };

  const offerLabel = offer => isAr
    ? (offer?.title_ar || offer?.title_en || offer?.source_title || '')
    : (offer?.title_en || offer?.source_title || '');

  const formatOfferMoney = value => Number(value || 0).toLocaleString(isAr ? 'ar-EG' : 'en-EG') + ' LE';

  const updateOfferCoach = async () => {
    const coaches = [...document.querySelectorAll('[data-sesh-offer-coach]')];
    const coach = coaches[coaches.length - 1];
    if (!coach) return;

    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers:{ Accept:'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();

      const status = coach.querySelector('[data-sesh-offer-status]');
      const suggest = coach.querySelector('[data-sesh-offer-suggestion]');
      if (!status || !suggest) return;

      const activeOffers = readActiveOffers(coach);
      const titles = new Set();
      (cart.cart_level_discount_applications || []).forEach(d => d?.title && titles.add(d.title));
      (cart.items || []).forEach(item => (item.discounts || []).forEach(d => d?.title && titles.add(d.title)));

      const lines = [];
      const totalDiscount = Number(cart.total_discount || 0);

      if (totalDiscount > 0) {
        lines.push({
          strong: i18n.offer_applied_short || 'Offer applied',
          detail: (i18n.current_saving || 'Current saving: ') + formatOfferMoney(totalDiscount / 100) +
            (titles.size ? ' · ' + [...titles].join(', ') : '')
        });
      }

      let pendingProductOffer = null;

      activeOffers.forEach(offer => {
        const handles = Array.isArray(offer?.eligible_product_handles) ? offer.eligible_product_handles : [];
        if (handles.length) {
          const eligibleSet = new Set(handles);
          const eligibleQty = (cart.items || []).reduce((sum,item) => eligibleSet.has(item.handle) ? sum + Number(item.quantity || 0) : sum, 0);
          if (eligibleQty <= 0) return;

          const requiredQty = Math.max(1, Number(offer.buy_quantity || 0) + Number(offer.get_quantity || 0));
          const alreadyApplied = titles.has(offer.source_title);

          if (eligibleQty < requiredQty) {
            const missing = requiredQty - eligibleQty;
            lines.push({
              strong: offerLabel(offer),
              detail: isAr
                ? ('ضيفي ' + missing.toLocaleString('ar-EG') + ' منتج مؤهل كمان عشان العرض يبقى جاهز للتطبيق.')
                : ('Add ' + missing + ' more eligible item' + (missing === 1 ? '' : 's') + ' to make this offer eligible.')
            });
            if (!pendingProductOffer) pendingProductOffer = offer;
          } else if (!alreadyApplied && totalDiscount <= 0) {
            lines.push({
              strong: offerLabel(offer),
              detail: isAr
                ? 'السلة مستوفية عدد القطع للعرض، وShopify هيطبّق الخصم تلقائيًا حسب قواعد العرض.'
                : 'Your cart meets the item requirement. Shopify will apply the discount automatically according to the offer rules.'
            });
          }
        }

        if (offer?.kind === 'free_shipping' && Number(cart.item_count || 0) > 0 && Number(offer.minimum_amount || 0) > 0) {
          const subtotal = Number(cart.items_subtotal_price || 0) / 100;
          const minimum = Number(offer.minimum_amount);
          if (subtotal >= minimum) {
            lines.push({
              strong: offerLabel(offer),
              detail: i18n.free_shipping_qualified || 'Your current product subtotal qualifies for free shipping in Egypt.'
            });
          } else {
            const remaining = Math.max(0, minimum - subtotal);
            lines.push({
              strong: offerLabel(offer),
              detail: isAr
                ? ('فاضلك ' + formatOfferMoney(remaining) + ' على حد الشحن المجاني.')
                : (formatOfferMoney(remaining) + ' more to reach the free-shipping threshold.')
            });
          }
        }
      });

      if (!lines.length) {
        if (Number(cart.item_count || 0) === 0 && activeOffers.length) {
          activeOffers.forEach(offer => {
            lines.push({
              strong: offerLabel(offer),
              detail: isAr
                ? (offer?.summary_ar || 'عرض تلقائي شغال حاليًا.')
                : (offer?.summary_en || 'Automatic offer currently active.')
            });
          });
        } else {
          lines.push({
            strong: '',
            detail: Number(cart.item_count || 0) > 0
              ? (i18n.offers_waiting || 'Active offers will appear here automatically as soon as your cart becomes eligible.')
              : (i18n.offers_none || 'There are no active automatic offers right now.')
          });
        }
      }

      status.textContent = '';
      lines.forEach(line => {
        const row = document.createElement('div');
        row.className = 'sesh-offer-coach__line';
        if (line.strong) {
          const strong = document.createElement('strong');
          strong.textContent = line.strong;
          row.appendChild(strong);
        }
        const detail = document.createElement('span');
        detail.textContent = line.detail;
        row.appendChild(detail);
        status.appendChild(row);
      });

      const inCart = new Set((cart.items || []).map(item => item.handle));
      let options = catalog().filter(x => x.available && x.inventory !== 0);

      if (pendingProductOffer && Array.isArray(pendingProductOffer.eligible_product_handles)) {
        const eligible = new Set(pendingProductOffer.eligible_product_handles);
        const offerOptions = options.filter(x => eligible.has(x.handle) && !inCart.has(x.handle));
        if (offerOptions.length) options = offerOptions;
      } else {
        options = options.filter(x => !inCart.has(x.handle));
      }

      const base = (cart.items || [])[0]?.handle;
      const baseItem = productByHandle(base);
      options = options
        .map(x => ({...x, score:stockScore(x) + (baseItem && x.category === baseItem.category ? 3 : 0) + (x.isNew ? 1 : 0)}))
        .sort((a,b) => b.score - a.score || a.price - b.price);

      suggest.innerHTML = '';
      if (cart.item_count > 0 && options[0]) {
        const x = options[0];
        suggest.className = 'sesh-offer-suggest';
        const img = document.createElement('img');
        img.src = x.image || '';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';

        const copy = document.createElement('div');
        const title = document.createElement('strong');
        title.textContent = x.title;
        const price = document.createElement('small');
        price.textContent = x.priceFormatted;
        copy.append(title, price);

        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.seshIntelOfferAdd = x.variantId;
        button.textContent = i18n.offer_add || i18n.action_add || 'Add';

        suggest.append(img, copy, button);
      }

      track('offer_coach_view', {
        item_count:Number(cart.item_count || 0),
        has_discount:totalDiscount > 0,
        active_offer_count:activeOffers.length
      });
    } catch (error) {}
  };

  const reviewTerms=[
    ['glow',['glow','نضارة','لمعان']],['texture',['texture','ملمس','ناعم','smooth']],['hydration',['hydrat','ترطيب','مرطب']],['scent',['scent','smell','ريحة','رائحة','عطر']],['pores',['pore','مسام']],['brightening',['bright','تفتيح','تصبغ']]
  ];
  const reviewRating = rev => {
    const e=rev.querySelector('.jdgm-rev__rating'); if(!e) return 0;
    const raw=e.dataset.score||e.getAttribute('data-score')||e.getAttribute('title')||e.getAttribute('aria-label')||''; const m=String(raw).match(/([0-5](?:\.\d+)?)/); return m?Number(m[1]):0;
  };
  const renderReviewIntel = () => {
    const reviews=[...document.querySelectorAll('.jdgm-rev')]; if(reviews.length<3||document.querySelector('[data-sesh-review-intel]')) return false;
    const parent=reviews[0].parentElement; if(!parent) return false;
    const counts=reviewTerms.map(([name,words])=>[name,reviews.filter(r=>words.some(w=>r.textContent.toLowerCase().includes(w))).length]).filter(x=>x[1]>0).sort((a,b)=>b[1]-a[1]).slice(0,3);
    const ratings=reviews.map(reviewRating).filter(Boolean), avg=ratings.length?(ratings.reduce((a,b)=>a+b,0)/ratings.length).toFixed(1):'';
    const box=document.createElement('div'); box.className='sesh-review-intel'; box.dataset.seshReviewIntel='';
    box.innerHTML='<div class="sesh-review-intel__top"><strong>'+i18n.reviews_heading+'</strong><small>'+i18n.reviews_based_on+' · '+reviews.length+'</small></div>'+
      (avg?'<small>'+i18n.reviews_rating+': '+avg+'★</small>':'')+'<div class="sesh-review-intel__chips">'+counts.map(([n,c])=>'<span>'+n+' · '+c+'</span>').join('')+'</div>';
    const filter=parent.querySelector('[data-sesh-review-filter]'); parent.insertBefore(box,filter||reviews[0]); track('review_intelligence_rendered',{reviews:reviews.length,topics:counts.map(x=>x[0]).join('|')}); return true;
  };

  const enhanceFinderCards = () => {
    document.querySelectorAll('.sesh-finder-product-card').forEach(card=>{
      if(card.querySelector('[data-sesh-compare-add]')) return; const href=card.querySelector('a[href*="/products/"]')?.href||''; const handle=href.split('/products/')[1]?.split('?')[0]; if(!handle)return;
      const actions=card.querySelector('.sesh-finder-product-card__actions'); if(actions){const b=document.createElement('button');b.type='button';b.dataset.seshCompareAdd=handle;b.textContent=i18n.action_compare||'Compare';actions.appendChild(b);}
    }); updateCompareButtons();
  };

  document.addEventListener('click',e=>{
    const goal=e.target.closest('[data-sesh-finder-goals] button'); if(goal){bump(goal.dataset.goal,5,'finder');setActiveInterest(goal.dataset.goal,'finder');track('finder_goal',{goal:goal.dataset.goal});}
    if(e.target.closest('[data-sesh-open-finder]')) track('finder_open');
    const cmp=e.target.closest('[data-sesh-compare-add]'); if(cmp){e.preventDefault();toggleCompare(cmp.dataset.seshCompareAdd);}
    const rem=e.target.closest('[data-sesh-compare-remove]'); if(rem){toggleCompare(rem.dataset.seshCompareRemove);}
    if(e.target.closest('[data-sesh-open-compare]')){renderCompare();openDialog('[data-sesh-compare-dialog]');}
    const copilotTrigger=e.target.closest('[data-sesh-open-copilot]');
    if(copilotTrigger){
      const route=copilotTrigger.dataset.seshSiaRoute||(document.querySelector('[data-sfw]')?'fragrance':'');
      const conciergeRoot=document.querySelector('[data-sesh-concierge]');
      if(route&&conciergeRoot) conciergeRoot.dataset.seshEntryRoute=route;
      if(route==='fragrance'){
        bump('fragrance',5,'page_context');
        setActiveInterest('fragrance','page_context');
      }
      openDialog('[data-sesh-copilot-dialog]');
      if(route&&window.SeshConciergeOpenRoute) window.SeshConciergeOpenRoute(route);
      loadConcierge();
      track('copilot_open',{route:route||'default'});
    }
    if(e.target.closest('[data-sesh-open-fragrance]')){openDialog('[data-sesh-fragrance-dialog]');track('fragrance_open');}
    if(e.target.closest('[data-sesh-intel-close]')) e.target.closest('dialog')?.close();
    const mood=e.target.closest('[data-sesh-fragrance-mood]'); if(mood) runFragrance(mood.dataset.seshFragranceMood);
    const off=e.target.closest('[data-sesh-intel-offer-add]'); if(off){const id=Number(off.dataset.seshIntelOfferAdd);rememberAdd(id);fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})}).then(()=>{if(typeof window.refreshCart==='function')window.refreshCart();setTimeout(updateOfferCoach,500);});}

    const qa=e.target.closest('[data-sesh-quick-add]');
    if(qa) rememberAdd(qa.dataset.variantId);

    const chatAdd=e.target.closest('[data-sesh-chat-add]');
    if(chatAdd) rememberAdd(chatAdd.dataset.seshChatAdd);

    const smartAdd=e.target.closest('[data-sesh-smart-add]');
    if(smartAdd) rememberAdd(smartAdd.dataset.variantId);

    const finderAddAll=e.target.closest('[data-sesh-finder-add-all]');
    if(finderAddAll){
      [...document.querySelectorAll('[data-sesh-finder-results-grid] [data-sesh-quick-add][data-variant-id]')]
        .forEach(btn=>rememberAdd(btn.dataset.variantId));
    }
    const productLink=e.target.closest('a[href*="/products/"]'); if(productLink){const h=productLink.href.split('/products/')[1]?.split('?')[0];const item=productByHandle(h);if(item){bump(item.category,.25,'product_click');item.goals.forEach(g=>bump(g,.25,'product_click'));const focus=primaryInterestForItem(item);if(focus)setActiveInterest(focus,'product_click');}}
    if(e.target.closest('[data-sesh-replenish-dismiss]')){const t=document.querySelector('[data-sesh-replenish]');if(t)t.hidden=true;}
  });

  document.addEventListener('sesh:interest',e=>{
    const keys=Array.isArray(e.detail?.keys)?e.detail.keys.filter(Boolean):[];
    const handles=Array.isArray(e.detail?.handles)?e.detail.handles.filter(Boolean):[];
    const source=e.detail?.source||'sia';

    keys.forEach(key=>bump(key,4,source));

    const handleItems=handles.map(productByHandle).filter(Boolean);
    const productFocus=handleItems.length?primaryInterestForItems(handleItems):'';
    const explicitFocus=keys.find(key=>key!=='skincare'&&interestLabels[key])||keys.find(key=>interestLabels[key]);
    const focus=productFocus||explicitFocus;

    if(focus){
      bump(focus,4,source);
      setActiveInterest(focus,source);
    }else{
      renderAdaptiveHome();
    }
  });

  document.addEventListener('submit',e=>{
    const form=e.target.closest('form[action*="/cart/add"]'); if(form){const id=form.querySelector('[name="id"]')?.value;if(id)rememberAdd(id);}
  });

  const init=()=>{
    captureAttribution();
    const currentProduct=document.querySelector('[data-sesh-product-data]');
    if(currentProduct?.dataset.handle){
      const viewed=productByHandle(currentProduct.dataset.handle);
      const sessionKey='sesh:viewed:'+currentProduct.dataset.handle;
      if(viewed){
        const p=profile(); p.lastViewedHandle=viewed.handle; saveProfile(p);
        if(!sessionStorage.getItem(sessionKey)){
          sessionStorage.setItem(sessionKey,'1');
          bump(viewed.category,1.5,'product_view');
          viewed.goals.forEach(g=>bump(g,2,'product_view'));
        }
        const focus=primaryInterestForItem(viewed);
        if(focus) setActiveInterest(focus,'product_view');
      }
    }

    const articleContext=document.querySelector('[data-sesh-article-context]');
    if(articleContext){
      try{
        const ctx=JSON.parse(articleContext.textContent||'{}');
        const focus=interestFromArticle([ctx.title,ctx.tags,ctx.content].filter(Boolean).join(' '));
        if(focus){
          bump(focus,3,'blog');
          setActiveInterest(focus,'blog');
          track('blog_interest',{interest:focus});
        }
      }catch(e){}
    }
    injectFinderShortcuts();
    injectSiaNavigation();
    renderAdaptiveHome();
    renderWhy();
    updateCompareButtons();
    enhanceFinderCards();
    const initialCoach=document.querySelector('[data-sesh-offer-coach]');
    if(initialCoach) updateOfferCoach();
    showReplenish();
    renderReviewIntel();

    const resultGrid=document.querySelector('[data-sesh-finder-results-grid]');
    if(resultGrid){
      let routineTimer;
      new MutationObserver(()=>{
        clearTimeout(routineTimer);
        routineTimer=setTimeout(()=>{
          renderRoutineTimeline();
          track('finder_results_changed');
        },80);
      }).observe(resultGrid,{childList:true});
    }

    const browseGrid=document.querySelector('[data-sesh-finder-browse-grid]');
    if(browseGrid){
      let browseTimer;
      new MutationObserver(()=>{
        clearTimeout(browseTimer);
        browseTimer=setTimeout(enhanceFinderCards,80);
      }).observe(browseGrid,{childList:true});
    }

    const cartForm=document.getElementById('AjaxCartForm');
    if(cartForm){
      let cartTimer;
      const refreshOfferCoach=()=>{
        clearTimeout(cartTimer);
        cartTimer=setTimeout(updateOfferCoach,120);
      };
      cartForm.addEventListener('cart-updated',refreshOfferCoach);
      new MutationObserver(refreshOfferCoach).observe(cartForm,{childList:true,subtree:true});
      document.addEventListener('cart-updated',refreshOfferCoach);
      document.addEventListener('cart:updated',refreshOfferCoach);
      document.addEventListener('cart:refresh',refreshOfferCoach);
    }

    setTimeout(renderReviewIntel,1200);
    setTimeout(renderReviewIntel,3500);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();